import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { Statistics, DateRange, StatisticsType } from '../models';

export enum EmailActionTypes {
  GetStatistics = '[Email Statistics] Get Statistics',
  GetStatisticsSuccess = '[Email Statistics] Get Statistics Success',
  GetStatisticsFail = '[Email Statistics] Get Statistics Fail',

  GetStatisticsOverTime = '[Email Statistics] Get Statistics Over Time',
  GetStatisticsOverTimeSuccess = '[Email Statistics] Get Statistics Over Time Success',
  GetStatisticsOverTimeFail = '[Email Statistics] Get Statistics Over Time Fail',

  GetDomainStatistics = '[Email Statistics] Get Domain Statistics',
  GetDomainStatisticsSuccess = '[Email Statistics] Get Domain Statistics Success',
  GetDomainStatisticsFail = '[Email Statistics] Get Domain Statistics Fail',

  GetSendingsStatistics = '[Email Statistics] Get Sendings Statistics',
  GetSendingsStatisticsSuccess = '[Email Statistics] Get Sendings Statistics Success',
  GetSendingsStatisticsFail = '[Email Statistics] Get Sendings Statistics Fail',

  DownloadCSV = '[Email Statistics] Download CSV',
  DownloadCSVSuccess = '[Email Statistics] Download CSV Success',
  DownloadCSVFailure = '[Email Statistics] Download CSV Failure',
}

export class GetStatistics implements Action {
  readonly type = EmailActionTypes.GetStatistics;
  constructor(public payload: { dateRange: DateRange; accountId: string }) {}
}

export class GetStatisticsSuccess implements Action {
  readonly type = EmailActionTypes.GetStatisticsSuccess;
  constructor(public payload: Statistics) {}
}

export class GetStatisticsFail implements Action {
  readonly type = EmailActionTypes.GetStatisticsFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetStatisticsOverTime implements Action {
  readonly type = EmailActionTypes.GetStatisticsOverTime;
  constructor(public payload: { timeSpans: number[]; accountId: string }) {}
}

export class GetStatisticsOverTimeSuccess implements Action {
  readonly type = EmailActionTypes.GetStatisticsOverTimeSuccess;
  constructor(public payload: Statistics[]) {}
}

export class GetStatisticsOverTimeFail implements Action {
  readonly type = EmailActionTypes.GetStatisticsOverTimeFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetDomainStatistics implements Action {
  readonly type = EmailActionTypes.GetDomainStatistics;
  constructor(public payload: { dateRange: DateRange; accountId: string }) {}
}

export class GetDomainStatisticsSuccess implements Action {
  readonly type = EmailActionTypes.GetDomainStatisticsSuccess;
  constructor(public payload: Statistics[]) {}
}

export class GetDomainStatisticsFail implements Action {
  readonly type = EmailActionTypes.GetDomainStatisticsFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class GetSendingsStatistics implements Action {
  readonly type = EmailActionTypes.GetSendingsStatistics;
  constructor(public payload: { dateRange: DateRange; accountId: string }) {}
}

export class GetSendingsStatisticsSuccess implements Action {
  readonly type = EmailActionTypes.GetSendingsStatisticsSuccess;
  constructor(public payload: Statistics[]) {}
}

export class GetSendingsStatisticsFail implements Action {
  readonly type = EmailActionTypes.GetSendingsStatisticsFail;
  constructor(public payload: HttpErrorResponse) {}
}

export class DownloadCSV implements Action {
  readonly type = EmailActionTypes.DownloadCSV;
  constructor(public payload: StatisticsType) {}
}

export class DownloadCSVSuccess implements Action {
  readonly type = EmailActionTypes.DownloadCSVSuccess;
}

export class DownloadCSVFailure implements Action {
  readonly type = EmailActionTypes.DownloadCSVFailure;
  constructor(public payload: HttpErrorResponse) {}
}

export type EmailActions =
  | GetStatistics
  | GetStatisticsSuccess
  | GetStatisticsFail
  | GetStatisticsOverTime
  | GetStatisticsOverTimeSuccess
  | GetStatisticsOverTimeFail
  | GetDomainStatistics
  | GetDomainStatisticsSuccess
  | GetDomainStatisticsFail
  | GetSendingsStatistics
  | GetSendingsStatisticsSuccess
  | GetSendingsStatisticsFail
  | DownloadCSV
  | DownloadCSVSuccess
  | DownloadCSVFailure;
